import { render, staticRenderFns } from "./storeOrgTree.vue?vue&type=template&id=1a4b50b0&scoped=true"
import script from "./storeOrgTree.vue?vue&type=script&lang=js"
export * from "./storeOrgTree.vue?vue&type=script&lang=js"
import style0 from "./storeOrgTree.vue?vue&type=style&index=0&id=1a4b50b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b50b0",
  null
  
)

export default component.exports